export const HYPER_ADDRESS = "0x94a2b7d01445f6713d01388121b432f3d03d1b88";
export const TOKENSALE_ADDRESS = "0x25783205f0f9a9260f5319313998a2b253d6dc8f";

export const NETWORKID_ACTIVE = "0x38";
export const NETWORKID_ACTIVE_DEC = "56";

export const ABI = [
  "function buyTokens(address referrer) external payable"
];

export const rateABI = [
  {
    "constant": true,
    "inputs": [],
    "name": "rate",
    "outputs": [{ "name": "", "type": "uint256" }],
    "type": "function",
  },
];

export const tokenAvaiableABI = [
	{
		"inputs": [],
		"name": "token",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export const balanceOfABI = [
	{
	  "constant": true,
	  "inputs": [{ "name": "_owner", "type": "address" }],
	  "name": "balanceOf",
	  "outputs": [{ "name": "balance", "type": "uint256" }],
	  "type": "function",
	}
  ];


export const RATE_TOKENSALE_STAGE1 = 600000;
export const RATE_TOKENSALE_STAGE2 = 400000;
export const RATE_TOKENSALE_STAGE3 = 300000;

export const TOTAL_TOKENSALE_STAGE1 = 100_000_000;
export const TOTAL_TOKENSALE_STAGE2 = 90_000_000;
export const TOTAL_TOKENSALE_STAGE3 = 80_000_000;

export const TOTAL_TOKEN_IN_CONTRACT_SALE = 320000000;

export const STAGES_PRESALE = [
	{	
		stage: 1, name: "Stage 1", total: 100_000_000, rate: 600_000, 
		tokenRemain: (320_000_000 - 100_000_000 - 50_000_000),
	},
	{
		stage: 2, name: "Stage 2", total: 90_000_000, rate: 400_000,
		tokenRemain: (320_000_000 - 100_000_000 - 90_000_000 - 50_000_000) 
	},
	{
		stage: 3, name: "Stage 3", total: 80_000_000, rate: 300_000 ,
		tokenRemain: (320_000_000 - 100_000_000 - 90_000_000 - 80_000_000 - 50_000_000) 
	},
  ];

 export const SERVER_URL = "https://api.hyperstake-ai.com";
 export const BASE_URL = "https://hyperstake-ai.com";
// export const SERVER_URL = "http://localhost:3001";
export const LOGO_URL = "https://hyperstake-ai.com/images/crypto/logo.png";
export const TOKEN_SYMBOL = "HYPER"